module.exports = function () {
    // front-page functionality goes here

};